import { render } from "./CadastroInline.vue?vue&type=template&id=695123bc&scoped=true"
import script from "./CadastroInline.vue?vue&type=script&lang=ts"
export * from "./CadastroInline.vue?vue&type=script&lang=ts"

import "./CadastroInline.vue?vue&type=style&index=0&id=695123bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-695123bc"

export default script